"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const React = require("react");
const LinkifyReact = require("linkify-react");
const _interopDefaultCompat = (e) => e && typeof e === "object" && "default" in e ? e.default : e;
function _interopNamespaceCompat(e) {
  if (e && typeof e === "object" && "default" in e) return e;
  const n = Object.create(null, { [Symbol.toStringTag]: { value: "Module" } });
  if (e) {
    for (const k in e) {
      n[k] = e[k];
    }
  }
  n.default = e;
  return Object.freeze(n);
}
const React__namespace = /* @__PURE__ */ _interopNamespaceCompat(React);
const LinkifyReact__default = /* @__PURE__ */ _interopDefaultCompat(LinkifyReact);
const Linkify = ({ children, shouldOpenInNewTab }) => /* @__PURE__ */ React__namespace.createElement(LinkifyReact__default, { options: shouldOpenInNewTab ? { target: "_blank" } : void 0 }, children);
exports.Linkify = Linkify;
//# sourceMappingURL=linkify.js.map
